import { translate } from "../../../../common/providers";

export const translateEnumTypes = (value) => value && translate(`form-studio.criteria.type.${value?.toLowerCase()}`);
